import { FC, useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../providers/AuthProvider";
import { PaginateProvider } from "../providers/PaginateProvider";
import { AccessProfileProvider } from "../providers/Access/AccessProfile/AccessProfileProvider";
import DsimConnectWidget from "../components/DsimConnectWidget/DsimConnectWidget";
import useIsMobileApp from "../hooks/useIsMobileApp";
import { CHAT_PATH, canAccessChat, isPathAllowedOnMobile } from "../utils/MobileChatRedirect";

interface Props {
    element?: any;
    path?: string;
}

export const AuthenticationGate: FC<Props> = () => {
    const [isLoading, setIsLoading] = useState(true);

    const { userLogged } = useAuth();

    const location = useLocation();
    const isMobile = useIsMobileApp();

    useEffect(() => {
        if (userLogged && location.pathname) {
            // handleFetch({ route: location.pathname }).then();
        }
    }, [userLogged, location.pathname]);

    useEffect(() => {
        const disposer = () => setTimeout(() => setIsLoading(false), 0);
        disposer();
    }, []);

    if (isLoading) {
        return <></>;
    }

    // If the user is not authenticated, redirect them to a logon page
    if (!userLogged) {
        return <Navigate to="/login-notice" />
    }

    // Mobile (navegador ou app): o usuário fica no chat da IA; qualquer outra rota
    // privada volta para ele, mesmo que a URL seja digitada.
    if (isMobile && canAccessChat(userLogged) && !isPathAllowedOnMobile(location.pathname)) {
        return <Navigate to={CHAT_PATH} replace />
    }

    // If they're a user, go ahead and continue to what they wanted to see
    return (
        <AccessProfileProvider>
            <PaginateProvider>
                <Outlet />
                <DsimConnectWidget />
            </PaginateProvider>
        </AccessProfileProvider>
    );
};